import { graphql } from "gql";

const INTERNAL_ADMIN_USER_QUERY = graphql(`
  query InternalAdminUser($id: [ID!]!) {
    internalAdminUser(id: $id) {
      ...InternalAdminUser
    }
  }
`);

export default INTERNAL_ADMIN_USER_QUERY;
